<template>
  <div class="cmp-b2b-royalty-main-container">
    <div v-if="!isMobileScreen" class="royalty-container">
      <div class="table-container">
        <RoyaltyTable />
      </div>
      <div class="chart-container">
        <div v-if="is_loaded_royalty_page_data" class="chart-content">
          <span class="chart_header"
            >{{ $t("detailsb2b_shop_turnover") }}
            {{ activeSubRouteItem.route }}</span
          >
          <div class="chart">
            <div class="legend">
              <v-list>
                <v-list-tile
                  v-for="(label, i) in reportShopDigital.labels"
                  :key="i"
                  @click="onClick(label, i)"
                  ><div
                    class="circle"
                    :style="{
                      backgroundColor: `${reportShopDigital.datasets[0].backgroundColor[i]}`,
                    }"
                  ></div>
                  <v-list-tile-content>
                    <v-list-tile-title
                      :class="{ strikethrough: label.click }"
                    
                    > {{label.text}}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </div>
            <div class="chart_">
              <DoughnutChart
                :default_currency="default_currency"
                :chartdata="reportShopDigital"
                :title="$t('detailsb2b_shop_turnover')"
              />
            </div>
          </div>
        </div>
        <div v-if="is_loaded_royalty_page_data" class="chart-content">
          <span class="chart_header"
            >{{ $t("detailsb2b_channel") }} {{ activeSubRouteItem.route }}</span
          >

          <div class="chart">
            <div class="legend">
              <v-list>
                <v-list-tile
                  v-for="(label, i) in reportChannel.labels"
                  :key="i"
                >
                  <div
                    class="circle"
                    :style="{
                      backgroundColor: `${reportChannel.datasets[0].backgroundColor[i]}`,
                    }"
                  ></div>

                  <v-list-tile-content>
                    <v-list-tile-title>  {{label.text}}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </div>
            <div class="chart_">
              <DoughnutChart
                :default_currency="default_currency"
                :chartdata="reportChannel"
                :title="$t('detailsb2b_channel')"
              />
            </div>
          </div>
        </div>
        <div v-if="is_loaded_royalty_page_data" class="chart-content">
          <span class="chart_header"
            >{{ $t("detailsb2b_digital_turnover") }}
            {{ activeSubRouteItem.route }}</span
          >

          <div class="chart">
            <div class="legend">
              <v-list>
                <v-list-tile
                  v-for="(label, i) in reportCountryDigital.labels"
                  :key="i"
                >
                  <div
                    class="circle"
                    :style="{
                      backgroundColor: `${reportCountryDigital.datasets[0].backgroundColor[i]}`,
                    }"
                  ></div>

                  <v-list-tile-content>
                    <v-list-tile-title >  {{label.text}}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </div>
            <div class="chart_">
              <DoughnutChart
                :default_currency="default_currency"
                :chartdata="reportCountryDigital"
                :title="$t('detailsb2b_digital_turnover')"
              />
            </div>
          </div>
        </div>
        <div v-if="is_loaded_royalty_page_data" class="chart-content">
          <span class="chart_header"
            >{{ $t("detailsb2b_physical_turnover") }}
            {{ activeSubRouteItem.route }}</span
          >

          <div class="chart">
            <div class="legend">
              <v-list>
                <v-list-tile
                  v-for="(label, i) in reportCountryPhysical.labels"
                  :key="i"
                >
                  <div
                    class="circle"
                    :style="{
                      backgroundColor: `${reportCountryPhysical.datasets[0].backgroundColor[i]}`,
                    }"
                  ></div>

                  <v-list-tile-content>
                    <v-list-tile-title >  {{label.text}}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </div>
            <div class="chart_">
              <DoughnutChart
                :default_currency="default_currency"
                :chartdata="reportCountryPhysical"
                :title="$t('detailsb2b_physical_turnover')"
              />
            </div>
          </div>
        </div>
        <div
          v-if="is_loaded_royalty_page_data"
          class="chart-content full-content"
        >
          <span class="chart_header"
            >{{ $t("detailsb2b_release") }} {{ activeSubRouteItem.route }}</span
          >
          <div class="chart_">
            <BarChart
              :default_currency="default_currency"
              :chartdata="reportRelease"
              :appDrawer="appDrawer"
              :title="$t('detailsb2b_release')"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="isMobileScreen" class="mobile-container">
      <div class="table-container">
        <RoyaltyTable />
      </div>
      <div class="chart-container">
        <swipe class="my-swipe" ref="mySwipe" :auto="0" :continuous="false">
          <swipe-item v-if="is_loaded_royalty_page_data">
            <span class="chart_header"
              >{{ $t("detailsb2b_shop_turnover") }}
              {{ activeSubRouteItem.route }}</span
            >

            <div class="chart">
              <div class="legend">
                <v-list>
                  <v-list-tile
                    v-for="(label, i) in reportShopDigital.labels"
                    :key="i"
                  >
                    <div
                      class="circle"
                      :style="{
                        backgroundColor: `${reportShopDigital.datasets[0].backgroundColor[i]}`,
                      }"
                    ></div>

                    <v-list-tile-content>
                      <v-list-tile-title
                      > {{label.text}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </div>
              <div class="chart_">
                <DoughnutChart
                  :default_currency="default_currency"
                  :chartdata="reportShopDigital"
                  :title="$t('detailsb2b_shop_turnover')"
                />
              </div>
            </div>
          </swipe-item>
          <swipe-item v-if="is_loaded_royalty_page_data">
            <span class="chart_header"
              >{{ $t("detailsb2b_channel") }}
              {{ activeSubRouteItem.route }}</span
            >

            <div class="chart">
              <div class="legend">
                <v-list>
                  <v-list-tile
                    v-for="(label, i) in reportChannel.labels"
                    :key="i"
                  >
                    <div
                      class="circle"
                      :style="{
                        backgroundColor: `${reportChannel.datasets[0].backgroundColor[i]}`,
                      }"
                    ></div>

                    <v-list-tile-content>
                      <v-list-tile-title
                       
                      >  {{label.text}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </div>
              <div class="chart_">
                <DoughnutChart
                  :default_currency="default_currency"
                  :chartdata="reportChannel"
                  :title="$t('detailsb2b_channel')"
                />
              </div>
            </div>
          </swipe-item>
          <swipe-item v-if="is_loaded_royalty_page_data">
            <span class="chart_header"
              >{{ $t("detailsb2b_digital_turnover") }}
              {{ activeSubRouteItem.route }}</span
            >

            <div class="chart">
              <div class="legend">
                <v-list>
                  <v-list-tile
                    v-for="(label, i) in reportCountryDigital.labels"
                    :key="i"
                  >
                    <div
                      class="circle"
                      :style="{
                        backgroundColor: `${reportCountryDigital.datasets[0].backgroundColor[i]}`,
                      }"
                    ></div>

                    <v-list-tile-content>
                      <v-list-tile-title
                        
                      > {{label.text}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </div>
              <div class="chart_">
                <DoughnutChart
                  :default_currency="default_currency"
                  :chartdata="reportCountryDigital"
                  :title="$t('detailsb2b_digital_turnover')"
                />
              </div>
            </div>
          </swipe-item>
          <swipe-item v-if="is_loaded_royalty_page_data">
            <span class="chart_header"
              >{{ $t("detailsb2b_physical_turnover") }}
              {{ activeSubRouteItem.route }}</span
            >

            <div class="chart">
              <div class="legend">
                <v-list>
                  <v-list-tile
                    v-for="(label, i) in reportCountryPhysical.labels"
                    :key="i"
                  >
                    <div
                      class="circle"
                      :style="{
                        backgroundColor: `${reportCountryPhysical.datasets[0].backgroundColor[i]}`,
                      }"
                    ></div>

                    <v-list-tile-content>
                      <v-list-tile-title
                       
                      > {{label.text}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </div>
              <div class="chart_">
                <DoughnutChart
                  :default_currency="default_currency"
                  :chartdata="reportCountryPhysical"
                  :title="$t('detailsb2b_physical_turnover')"
                />
              </div>
            </div>
          </swipe-item>
          <swipe-item v-if="is_loaded_royalty_page_data">
            <span class="chart_header"
              >{{ $t("detailsb2b_release") }}
              {{ activeSubRouteItem.route }}</span
            >
            <div class="chart_">
              <BarChart
                :default_currency="default_currency"
                :chartdata="reportRelease"
                :appDrawer="appDrawer"
                :title="$t('detailsb2b_release')"
              />
            </div>
          </swipe-item>
        </swipe>
      </div>
    </div>
  </div>
</template>

<script>
import { B2BStoreNamespace as storeNS } from "../../store/index";
import { mapGetters, mapActions } from "vuex";
import { clientName } from "../../services/http-client";
import * as types from "../../store/types";
import { GChart } from "vue-google-charts";
import BarChart from "../charts/bar-chart";
import BarVerticalChart from "../charts/bar-vertical-chart";
import LineChart from "../charts/line-chart";
import DoughnutChart from "../charts/doughnut-chart";
import RoyaltyTable from "./royalties-table";
import { Swipe, SwipeItem } from "vue-swipe";
import { isMobile,downloadPDF } from "../../../../utility";

import { isNumber } from "ramda-adjunct";
export default {
  components: {
    GChart,
    BarChart,
    LineChart,
    RoyaltyTable,
    BarVerticalChart,
    DoughnutChart,
    Swipe,
    SwipeItem,
  },

  data() {
    return {
      clientName: clientName,
      isMobileScreen: false,
    };
  },
  created() {},
  mounted() {
    if (isMobile()) {
      this.isMobileScreen = true;
    } else {
      this.isMobileScreen = false;
    }
    const param = this.$router.currentRoute.params["royaltyDate"];
    if (param) {
      this[types.B2B_FETCH_ROYALTIES_BY_YEAR]();
    }
  },
  computed: {
    ...mapGetters(storeNS, {
      user: "user",
      is_loaded_royalty_page_data: "is_loaded_royalty_page_data",
      appDrawer: "appDrawer",
      report_channel: "report_channel",
      report_release: "report_release",
      report_country_physical: "report_country_physical",
      report_shop_digital: "report_shop_digital",
      report_country_digital: "report_country_digital",
      activeSubRouteItem: "activeSubRouteItem",
    }),
    default_currency:function(){
       return this.user?.system_currency ||'';
    },
    reportCountryDigital: function () {
      if (!this.report_country_digital) {
        return {};
      }

      let report = {
        labels: [],
        datasets: [
          {
            label: "Digital Turnover",
            backgroundColor: "#4FE890",
            data: [],
            backgroundColor: [
              "#64C896",
              "#E6DC64",
              "#FF6E6E",
              "#7878F0",
              "#E682BE",
            ],
          },
        ],
      };
      let report_country_digital = this.report_country_digital.map((c) => {
        c.turnover = !isNumber(c?.turnover)
          ? parseFloat(c?.turnover?.replace(/\,/g, ""))
          : c?.turnover;
        return c;
      });
      const total_country_digital = report_country_digital
        .map((c) => Math.abs(c?.turnover))
        .reduce((accm, cur) => accm + cur, 0);

      report_country_digital.forEach((e) => {
        let salePercentage =
          (Math.abs(e.turnover) / total_country_digital) * 100;
        const label = e.item + " " + salePercentage.toFixed(1) + "%";
        report.labels.push({ text: label, click: false });
        report.datasets[0].data.push(e.turnover);
      });

      return report;
    },
    reportCountryPhysical: function () {
      if (!this.report_country_physical) {
        return {};
      }

      let report = {
        labels: [],
        datasets: [
          {
            label: "Digital Turnover",
            backgroundColor: "#4FE890",
            data: [],
            backgroundColor: [
              "#64C896",
              "#E6DC64",
              "#FF6E6E",
              "#7878F0",
              "#E682BE",
            ],
          },
        ],
      };
      let report_country_physical = this.report_country_physical.map((c) => {
        c.turnover = !isNumber(c?.turnover)
          ? parseFloat(c?.turnover?.replace(/\,/g, ""))
          : c?.turnover;
        return c;
      });
      const total_country_physical = report_country_physical
        .map((c) => Math.abs(c?.turnover))
        .reduce((accm, cur) => accm + cur, 0);

      report_country_physical.forEach((e) => {
        let salePercentage =
          (Math.abs(e.turnover) / total_country_physical) * 100;
        console.log("salePercentage", salePercentage);
        const label = e.item + " " + salePercentage.toFixed(1) + "%";
        report.labels.push({ text: label, click: false });
        report.datasets[0].data.push(e.turnover);
      });

      return report;
    },
    reportShopDigital: function () {
      if (!this.report_shop_digital) {
        return {};
      }

      let report = {
        labels: [],
        datasets: [
          {
            label: "Digital Turnover",
            backgroundColor: "#4FE890",
            data: [],
            backgroundColor: [
              "#64C896",
              "#E6DC64",
              "#FF6E6E",
              "#AFAFAF",
              "#44A1B7",
              "#F0A152",
              "#385090",
              "#121212",
              "#5DA771",
              "#E682BE",
            ],
          },
        ],
      };
      let report_shop_digital = this.report_shop_digital.map((c) => {
        c.turnover = !isNumber(c?.turnover)
          ? parseFloat(c?.turnover?.replace(/\,/g, ""))
          : c?.turnover;
        return c;
      });
      const total_shop_digital = report_shop_digital
        .map((c) => Math.abs(c?.turnover))
        .reduce((accm, cur) => accm + cur, 0);

      report_shop_digital.forEach((e) => {
        let salePercentage = (Math.abs(e.turnover) / total_shop_digital) * 100;

        const label = e.item + " " + salePercentage.toFixed(1) + "%";
        report.labels.push({ text: label, click: false });
        report.datasets[0].data.push(e.turnover);
      });

      return report;
    },
    reportChannel: function () {
      if (!this.report_channel) {
        return {};
      }

      let report = {
        labels: [],
        datasets: [
          {
            label: "Digital Turnover",
            backgroundColor: "#4FE890",
            data: [],
            backgroundColor: [
              "#64C896",
              "#E6DC64",
              "#FF6E6E",
              "#AFAFAF",
              "#44A1B7",
              "#F0A152",
              "#385090",
              "#121212",
              "#5DA771",
              "#E682BE",
            ],
          },
        ],
      };
      let report_channel = this.report_channel.map((c) => {
        c.turnover = !isNumber(c?.turnover)
          ? parseFloat(c?.turnover?.replace(/\,/g, ""))
          : c?.turnover;
        return c;
      });
      const total_channel = report_channel
        .map((c) => Math.abs(c?.turnover))
        .reduce((accm, cur) => accm + cur, 0);

      report_channel.forEach((e) => {
        let salePercentage = (Math.abs(e.turnover) / total_channel) * 100;
        const label = e.item + " " + salePercentage.toFixed(1) + "%";
        report.labels.push({ text: label, click: false });
        report.datasets[0].data.push(e.turnover);
      });

      return report;
    },
    reportRelease: function () {
      if (!this.report_release) {
        return {};
      }

      let report = {
        labels: [],
        datasets: [
          {
            label: "Release 2020",
            backgroundColor: "#4FE890",
            data: [],
            barThickness: 8,
            barPercentage: 0.5,
            xAxis: {
              labels: {
                useHTML: true,
                style: {
                  width: 100,
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                },
              },
            },
          },
        ],
      };
      this.report_release.forEach((c) => {
        c.turnover = !isNumber(c?.turnover)
          ? parseFloat(c?.turnover?.replace(/\,/g, ""))
          : c?.turnover;
        report.labels.push(c.item);
        report.datasets[0].data.push(c.turnover);
      });

      return report;
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [types.B2B_FETCH_ROYALTIES_BY_YEAR]: types.B2B_FETCH_ROYALTIES_BY_YEAR,
    }),
    onClick(label, index) {
      console.log("label", label);
      label.click = !label.click;
    },
    onChartReady(chart, google) {
      this.chartsLib = google;
    },
  },
};
</script>

<style lang="scss" >
.cmp-b2b-royalty-main-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  .royalty-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    .table-container {
      margin: 15px;
    }
    .chart-container {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      flex-wrap: wrap;
      width: 100%;
      position: relative;
      gap: 1rem;
      margin-top: 20px;
      margin-bottom: 30px;
      .chart-content {
        display: flex;
        border: 1px solid #fff;
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 10px 30px #00000015;
        border-radius: 15px;
        opacity: 1;
        padding: 0px 20px;
        width: 48%;
        overflow: auto;
        flex-direction: column;
        height: 350px;
        @media (min-width: 320px) and (max-width: 800px) {
          width: 100%;
        }
        &.full-content {
          width: 98.5%;
        }
        .chart_header {
          color: #282828;
          font-size: 14px;
          margin-top: 22px;
          padding-bottom: 20px;
          font-weight: bold;
        }
        .chart_ {
          display: flex;
          flex-direction: column;
          overflow: hidden;
          padding: 5px;
          height: 100%;
          div {
            display: flex !important;
            width: 100% !important;
            max-width: 100% !important;
            overflow: hidden;
            margin: 30px 8px 60px 0;
            canvas {
              height: none !important;
            }
            @media (min-width: 320px) and (max-width: 800px) {
              margin-bottom: 0px;
            }
          }
        }
        .chart {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          overflow: hidden;
          height: 100%;
          width: 100%;
          .legend {
            display: flex;
            flex-direction: column;
            margin-bottom: 60px;
            overflow: hidden;
            width: 60%;
            @media only screen and (max-width: 992px) {
              width: 50%;
            }
            .list__tile {
              display: flex;
              align-items: center;
              height: 24px;
              font-size: 14px;
              padding: 0px;
              .circle {
                width: 15px;
                height: 14px;
                border-radius: 50px;
              }
              .list__tile__content {
                padding-left: 5px;
                cursor: pointer;
                width: 100%;
                line-height: 24px;

                .list__tile__title {
                  color: #5e5e5e;
                  font-size: 13px;
                  &.strikethrough {
                    position: relative;
                  }

                  &.strikethrough:before {
                    border-bottom: 2px solid #757373;
                    position: absolute;
                    content: "";
                    width: 95%;
                    height: 55%;
                  }
                }
              }
            }
          }
          .chart_ {
            display: flex;
            height: 100%;
            overflow: hidden;

            justify-content: flex-end;

            div {
              display: flex !important;
              width: 100% !important;
              max-width: 100% !important;
              overflow: hidden;
              margin: 30px 8px 60px 0;
              canvas {
                height: none !important;
              }
              @media (min-width: 320px) and (max-width: 800px) {
                margin-bottom: 0px;
              }
            }
          }
        }
      }
    }
  }
  .mobile-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    .table-container {
      margin-bottom: 20px;
    }
    .chart-container {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      width: 100%;
      height: 100%;
      .my-swipe {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        .chart_header {
          color: #282828;
          font-size: 14px;
          margin-top: 22px;
          padding-bottom: 20px;
          padding-left: 15px;
          font-weight: bold;
        }
        .chart_ {
          display: flex;
          flex-direction: column;
          overflow: hidden;
          padding: 5px;
          height: 100%;
          div {
            display: flex !important;
            width: 100% !important;
            max-width: 100% !important;
            overflow: hidden;
            //margin: 30px 8px 60px 0;
            canvas {
              height: none !important;
            }
            @media (min-width: 320px) and (max-width: 800px) {
              margin-bottom: 0px;
            }
          }
        }
        .mint-swipe-items-wrap {
          border: 1px solid #fff;
          background: #fff 0 0 no-repeat padding-box;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
          border-radius: 15px;
          opacity: 1;
          padding: 0 10px;
          height: 100% !important;
          width: 93% !important;
          max-width: 93% !important;
          display: flex;
          width: 100%;
          overflow: hidden;
          flex-direction: column;
          margin-bottom: 40px;
          align-items: center;
          margin-top: 10px;
          margin-left: 10px;
          .mint-swipe-item {
            display: flex;
            width: 100%;
            overflow: auto;
            flex-direction: column;
            .chart {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              overflow: hidden;
              height: 100%;
              width: 100%;
              .legend {
                display: flex;
                flex-direction: column;

                overflow: hidden;
                .list__tile {
                  display: flex;
                  align-items: center;
                  height: 24px;
                  font-size: 14px;
                  &:hover {
                    background: none !important;
                  }
                  .circle {
                    width: 15px;
                    height: 14px;
                    border-radius: 50px;
                  }
                  .list__tile__content {
                    padding-left: 5px;
                    cursor: pointer;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 100%;
                    line-height: 24px;

                    .list__tile__title {
                      color: #5e5e5e;
                      font-size: 13px;
                    }
                  }
                }
              }
              .chart_ {
                display: flex;
                height: 55%;
                overflow: hidden;
                min-width: 60%;
                div {
                  display: flex !important;
                  width: 100% !important;
                  max-width: 100% !important;
                  overflow: hidden;
                  //margin: 30px 8px 60px 0;
                  canvas {
                    height: none !important;
                  }
                  @media (min-width: 320px) and (max-width: 480px) {
                    margin-bottom: 0px;
                  }
                }
              }
            }
          }
        }

        .mint-swipe-indicators {
          bottom: 18px !important;
          .mint-swipe-indicator {
            width: 12px !important;
            height: 12px !important;
            display: inline-block;
            border-radius: 100%;
            background: #fff !important;
            margin: 0 5px !important;
            opacity: 1 !important;
            border: 1px solid #282828 !important;
            &.is-active {
              background: #282828 !important;
            }
          }
        }
      }
    }
  }
  .list__tile--link:hover {
    background: none !important;
  }
}
</style>


